export default __webpack_public_path__ + "images/connection.569530f.png";